module.exports = __webpack_public_path__ + "static/media/idiyappam.9f35ec57.jpg";